module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_shinjuku-f17009ddfaf2a539f9007bd9a462cdc5.jpg";